import React, { useState } from 'react';
import Stepper, { Step } from 'components/ui/Stepper';
import { Breadcrumbs, Button, ButtonGroup, Crumb } from 'components/ui';
import { routes } from 'constants/config';
import { X } from 'react-feather';
import ExitAddProfileModal from './ExitAddProfileModal';
import AddProfileStepOne from './AddProfileStepOne';

const AddProfileContainer = props => {
  const [currentStep, setCurrentStep] = useState(1);
  const [jobTitle, setJobTitle] = useState('');
  const [selectedSkills] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState([]);
  // const [selectedGroups, setSelectedGroups] = useState([]);
  const [confirmExit, setConfirmExit] = useState(false);
  const canContinue = () => {
    if (currentStep === 1 && jobTitle.length > 0) return true;
    if (currentStep > 1 && jobTitle.length > 0 && selectedSkills?.length > 0)
      return true;
    return false;
  };
  return (
    <div className="container mt-48">
      <div>
        <Breadcrumbs
          parentUrl={routes.SKILLS.PROFILES}
          parentTitle={t('skills.sidebar.profiles')}
          className="mr-24 mt-1 mb-1"
        >
          <Crumb>{t('skills.add_profile')}</Crumb>
        </Breadcrumbs>
      </div>
      <div className="d-f w-100p mt-24">
        <div className="d-f w-100p ai-c fd-c SkillProfiles-addCard">
          <Stepper>
            <Step
              label={t('skills.job_title')}
              isComplete={currentStep > 1}
              isActive={currentStep === 1}
              onClick={() => setCurrentStep(1)}
              component={
                <AddProfileStepOne
                  setJobTitle={setJobTitle}
                  jobTitle={jobTitle}
                  setCurrentStep={setCurrentStep}
                />
              }
            />
            <Step
              label={t('skills.add_skills')}
              isComplete={currentStep > 2}
              isActive={currentStep === 2}
              onClick={() => (jobTitle.length > 0 ? setCurrentStep(2) : {})}
              disabled={jobTitle.length === 0}
            />
            <Step
              label={t('skills.proficiency')}
              isComplete={currentStep > 3}
              isActive={currentStep === 3}
              onClick={() =>
                jobTitle.length > 0 && selectedSkills?.length > 0
                  ? setCurrentStep(3)
                  : {}
              }
              disabled={jobTitle.length === 0 || selectedSkills?.length === 0}
            />
            <Step
              label={t('skills.add_learners')}
              isComplete={currentStep > 4}
              isActive={currentStep === 4}
              onClick={() =>
                jobTitle.length > 0 && selectedSkills?.length > 0
                  ? setCurrentStep(4)
                  : {}
              }
              disabled={jobTitle.length === 0 || selectedSkills?.length === 0}
            />
            <Step
              label={t('actions.preview')}
              isComplete={currentStep > 5}
              isActive={currentStep === 5}
              onClick={() =>
                jobTitle.length > 0 && selectedSkills?.length > 0
                  ? setCurrentStep(5)
                  : {}
              }
              disabled={jobTitle.length === 0 || selectedSkills?.length === 0}
            />
          </Stepper>
        </div>
        <button
          className="SeismicContentModal-header--close u-resetBtn"
          onClick={() => setConfirmExit(true)}
          type="button"
          data-testid="close"
          aria-label="Close Modal"
        >
          <X />
        </button>
      </div>
      {confirmExit && (
        <ExitAddProfileModal
          shouldSave={currentStep > 2}
          closeModal={() => setConfirmExit(false)}
        />
      )}
      <div className="mt-24 mr-24">
        <ButtonGroup alignEnd>
          {currentStep > 1 && (
            <Button
              type="cancel"
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              {t('common.previous')}
            </Button>
          )}
          {currentStep < 5 && canContinue() && (
            <Button
              className="Button--customColor"
              onClick={() => setCurrentStep(currentStep + 1)}
            >
              {t('common.next')}
            </Button>
          )}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default AddProfileContainer;
